import useMedia from 'react-use/lib/useMedia';

import { DialogVariant } from './context';

const MOBILE_MEDIA_QUERY = '(max-width: 599.95px)';

export interface FullScreenState {
  isFullScreen: boolean;
  isFullScreenLayout: boolean;
}

export const useIsFullScreen = (variant: DialogVariant): FullScreenState => {
  const isMobile = useMedia(MOBILE_MEDIA_QUERY, false);
  const isFullScreen = variant === 'fullScreen' || isMobile;
  const isFullScreenLayout = variant === 'default' && !isFullScreen;
  return { isFullScreen, isFullScreenLayout };
};
